import { render, staticRenderFns } from "./OrganPersonContactInfoView.vue?vue&type=template&id=337e3231&scoped=true"
import script from "./OrganPersonContactInfoView.vue?vue&type=script&lang=js"
export * from "./OrganPersonContactInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e3231",
  null
  
)

export default component.exports